import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ErrorTypes from './ErrorTypes';
import './ErrorMessage.scss';

const ErrorMessage = ({ error, testId }) => {
	const errorMessage = (ErrorTypes[error] && ErrorTypes[error].message) || error;
	const errorType = (ErrorTypes[error] && ErrorTypes[error].type) || 'error';

	return (
		<div className={cx('onboarding-error', `onboarding-error--${errorType}`)}>
			<div className="onboarding-error__icon">!</div>
			<div className="onboarding-error__message" data-test={testId}>
				{errorMessage}
			</div>
		</div>
	);
};

ErrorMessage.propTypes = {
	error: PropTypes.node.isRequired,
};

export default ErrorMessage;
